import { Input } from 'antd'
import React from 'react'
import css from '../index.module.less'

interface Props {
  placeholder: string
  onChange: any
  onSearch: any
  width: number
  theme?: string
}

export const SearchInput: React.FC<Props> = (props) => {
  const { placeholder, onChange, onSearch, width, theme } = props
  return (
    <div className={theme == 'dark' ? css.darkSearchInp : ''}>
      <Input
        style={{ width: width }}
        onPressEnter={onSearch}
        className={css.searchInp + ' ' + (theme == 'dark' ? css.darkInp : '')}
        suffix={
          <span
            onClick={onSearch}
            className={
              'iconfont icon-sousuo' +
              ' ' +
              (theme == 'dark' ? css.darkIcon : css.searchIcon)
            }
          ></span>
        }
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  )
}

export default SearchInput
